import { useState } from "react";

const MapMiniLogic = (defaultExapnded?: boolean) => {
  const [isMapExpanded, setIsMapExpanded] = useState(defaultExapnded);
  return { isMapExpanded, setIsMapExpanded };
};

export default MapMiniLogic;
